// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const tableTaggingParams: any = {
  adminCustomers: {
    true: {
      itemDescription: 'gestaoDeUsuarios_adminOn',
      itemName: 'check_box:admin_on'
    },
    false: {
      itemDescription: 'gestaoDeUsuarios_adminOff',
      itemName: 'check_box:admin_off'
    }
  },
  financialCustomers: {
    true: {
      itemDescription: 'gestaoDeUsuarios_visualizarFinancasOn',
      itemName: 'check_box:visualizar_financas_on'
    },
    false: {
      itemDescription: 'gestaoDeUsuarios_visualizarFinancasOff',
      itemName: 'check_box:visualizar_financas_off'
    }
  },
  ordersViewCustomers: {
    true: {
      itemDescription: 'gestaoDeUsuarios_visualizarPedidosOn',
      itemName: 'check_box:visualizar_pedidos_on'
    },
    false: {
      itemDescription: 'gestaoDeUsuarios_visualizarPedidosOff',
      itemName: 'check_box:visualizar_pedidos_off'
    }
  },
  ordersViewPriceCustomers: {
    true: {
      itemDescription: 'gestaoDeUsuarios_visualizarPrecosOn',
      itemName: 'check_box:visualizar_precos_on'
    },
    false: {
      itemDescription: 'gestaoDeUsuarios_visualizarPrecosOff',
      itemName: 'check_box:visualizar_precos_off'
    }
  },
  ordersInputCustomers: {
    true: {
      itemDescription: 'gestaoDeUsuarios_comprarOn',
      itemName: 'check_box:comprar_on'
    },
    false: {
      itemDescription: 'gestaoDeUsuarios_comprarOff',
      itemName: 'check_box:comprar_off'
    }
  },
  fabricationViewCustomers: {
    true: {
      itemDescription: 'gestaoDeUsuarios_corteEDobraOn',
      itemName: 'check_box:corte_e_dobra_on'
    },
    false: {
      itemDescription: 'gestaoDeUsuarios_corteEDobraOff',
      itemName: 'check_box:corte_e_dobra_off'
    }
  }
};
